import { render, staticRenderFns } from "./PhotoViewer.vue?vue&type=template&id=78342b8b&scoped=true&"
import script from "./PhotoViewer.vue?vue&type=script&lang=js&"
export * from "./PhotoViewer.vue?vue&type=script&lang=js&"
import style0 from "./PhotoViewer.vue?vue&type=style&index=0&lang=less&"
import style1 from "./PhotoViewer.vue?vue&type=style&index=1&id=78342b8b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78342b8b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
